module.exports = __webpack_public_path__ + "img/time_management_de.13fd69d9.svg";